export function getParams(state) {
    return state.params
}

export function sublinesList(state) {
    return state.sublinesList;
}


// WEBPACK FOOTER //
// ./src/modules/sublinesb/getters.js